import { render } from "./HeadeurComponent.vue?vue&type=template&id=4887067a&scoped=true"
import script from "./HeadeurComponent.vue?vue&type=script&lang=js"
export * from "./HeadeurComponent.vue?vue&type=script&lang=js"

import "./HeadeurComponent.vue?vue&type=style&index=0&id=4887067a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4887067a"]])

export default __exports__